//#region Libraries
import { Column } from "components/styles";
import styled from "styled-components";
//#endregion

export const Container = styled(Column)`
    width: 350px;
    padding: 0 10px;
    padding-bottom: 5px;
`;